

import React, { FC } from 'react';
import { M09ShopTheLookGalleryBlockItem } from './m09-shop-the-look-gallery-block-item.component';
import { IM09ShopTheLookGallery, IM09ShopTheLookGalleryItem } from '@montana/models/generated/cms.interface';

export enum SHOP_THE_LOOK_GALLERY_ALIGNMENTS {
    LEFT = 'left',
    RIGHT = 'right',
}

export const M09ShopTheLookGalleryBlock: FC<IM09ShopTheLookGallery> = (props: IM09ShopTheLookGallery) => {

    const {
        items,
        alignment,
    } = props;

    // This is to align items right inside of the css grid, very hacky
    const positions: number[] = items ? calcPositions(items, alignment) : [1];

    return (
        <div className={`shop-the-look-gallery-block shop-the-look-gallery-block--${alignment}`}>
            { items?.map((item: IM09ShopTheLookGalleryItem, index: number) => (
                <M09ShopTheLookGalleryBlockItem key={index} position={positions[index]} {...item} />
            ))}
        </div>
    );
};

const calcPositions = (items: IM09ShopTheLookGalleryItem[], alignment?: string): number[] => {
    const numberOfColumns = 12;
    const item1Width = Number(items[0]?.width) || 1;
    const item2Width = Number(items[1]?.width) || 1;

    if (items.length === 2) {
        if ((item1Width + item2Width) > numberOfColumns) {
            if (alignment === SHOP_THE_LOOK_GALLERY_ALIGNMENTS.RIGHT) {
                return [
                    1 + numberOfColumns - item1Width,
                    1 + numberOfColumns - item2Width,
                ];
            } else {
                return [
                    1,
                    1,
                ];
            }
        } else {
            if (alignment === SHOP_THE_LOOK_GALLERY_ALIGNMENTS.RIGHT) {
                return [
                    1 + numberOfColumns - item1Width - item2Width,
                    1 + numberOfColumns - item2Width,
                ];
            } else {
                return [
                    1,
                    item1Width + 1,
                ];
            }
        }
    } else {
        if (alignment === SHOP_THE_LOOK_GALLERY_ALIGNMENTS.RIGHT) {
            return [
                1 + numberOfColumns - item1Width,
            ];
        } else {
            return [
                1
            ];
        }
    }
};